import React, { useRef } from "react";
import { Box, Paper } from "@mui/material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

interface RichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  height?: number;
  readOnly?: boolean;
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  placeholder = "Write your message here...",
  height = 200,
  readOnly = false,
}) => {
  const quillRef = useRef<ReactQuill>(null);

  // Quill modules configuration
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ align: [] }],
      ["link", "image"],
      ["clean"],
    ],
  };

  // Quill formats
  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "indent",
    "align",
    "link",
    "image",
  ];

  return (
    <Box
      sx={{
        "& .ql-container": {
          height: height - 42, // Subtract toolbar height
          fontSize: "1rem",
          fontFamily: "inherit",
          borderBottomLeftRadius: 4,
          borderBottomRightRadius: 4,
        },
        "& .ql-editor": {
          minHeight: height - 42,
        },
        "& .ql-toolbar": {
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
        },
      }}
    >
      <Paper
        elevation={0}
        sx={{
          border: "1px solid rgba(0, 0, 0, 0.23)",
          borderRadius: 1,
          overflow: "hidden",
        }}
      >
        <ReactQuill
          ref={quillRef}
          theme="snow"
          value={value}
          onChange={onChange}
          modules={modules}
          formats={formats}
          placeholder={placeholder}
          readOnly={readOnly}
        />
      </Paper>
    </Box>
  );
};

export default RichTextEditor;
